import {useMutation, useQuery} from "react-query";
import {createCustomer} from "../api/mutations/customer";
import Storage from "../utils/Storage";
import {COMPANY, COMPANY_INTEGRATIONS, CUSTOMER_DETAILS, NEXT_PENTEST_NAME} from "./utils/constants";
import {customerDetails} from "../api/queries/customer";
import axios from "axios";
import { useAppMode } from "../Providers/AppModeProvider";
import { APP_MODE } from "../utils/constants";

export const useCreateCustomer = () => {
    return useMutation(createCustomer)
}

export const useCustomerDetails = (enabled = true) => {
    return useQuery(CUSTOMER_DETAILS, customerDetails, {
        retry: false, staleTime: Infinity,
        enabled: Boolean(Storage.token) && enabled,
    })
}

export const useNextPentestName = (enabled = true) => {
    return useQuery(NEXT_PENTEST_NAME, async () => {
        let res = await axios.post(`/temp/generate_pentest_name`)
        return res?.data?.nextPentestName
    }, {
        enabled
    })
}

export const useCompany = (company_id) => {
    return useQuery([COMPANY, {company_id}], async () => {
        let res = await axios.get(`/company/${company_id}`)
        return res.data
    }, {
        enabled: !!company_id
    })
}

export const useInviteTeam = () => {
  return useMutation(async (payload) => {
    const response = await axios.post('/customer/invite_team', payload);
    return response.data;
  });
};


export const useTrialStats = (options = {}) => {
  const companyId = axios.defaults.headers.common['company_id'];

  return useQuery(
    ['trialStats', companyId],
    async () => {
      const res = await axios.get('/customer/trial_stats', {
        headers: { 
          company_id: companyId,
          'Cache-Control': 'no-cache'
         },
      });
      return res.data;
    },
    {
      enabled: !!companyId && (options?.enabled ?? true), // gate by userData
      retry: false,
    }
  );
};



export const useUpdateCompanyName = (options) => {
    return useMutation(async (data) => {
        let res = await axios.post(`/company/${data.company_id}/update`, ...data?.companyDetails)
        return res.data;
    }, options)
}

export const useCompanyIntegrations = () => {
  return useQuery([COMPANY_INTEGRATIONS, {}], async () => {
      let res = await axios.get(`/company/integrations/enabled`)
      return res.data
  })
}